import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {
  ContainerItemModel,
  ContainerModel,
} from '@app/models/server/layout.model';
import { AsyncPipe, TitleCasePipe } from '@angular/common';
import { EventService } from '@app/services/util-services/root-services/event-service';
import { Observable, of, switchMap } from 'rxjs';
import { HttpClientService } from '@app/services/util-services/root-services/http-client.service';
import { B2bNewCheckboxListComponent } from '@app/new-ui-lib/b2b-list/components/b2b-new-checkbox-list/b2b-new-checkbox-list.component';
import { B2bNewRadioCheckboxListComponent } from '@app/new-ui-lib/b2b-list/components/b2b-new-radio-checkbox-list/b2b-new-radio-checkbox-list.component';

@Component({
  selector: 'app-b2b-desktop-filter-card',
  templateUrl: './b2b-desktop-filter-card.component.html',
  styleUrls: ['./b2b-desktop-filter-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    TitleCasePipe,
    AsyncPipe,
    B2bNewCheckboxListComponent,
    B2bNewRadioCheckboxListComponent,
  ],
})
export class B2bDesktopFilterCardComponent implements OnInit {
  @Input() compData: {
    container: ContainerModel;
  };

  finalContainer$: Observable<ContainerModel>;

  constructor(
    public eventService: EventService,
    private httpClientService: HttpClientService,
  ) {}

  ngOnInit() {
    this.initApi();
  }

  initApi() {
    this.finalContainer$ = this.httpClientService
      ?.getDynamicContainersData(
        this.compData?.container?.apiURL,
        this.compData?.container?.isCacheEnabled,
        this.compData?.container?.key,
        this.compData?.container?.apiRequestBody,
        null,
        true,
      )
      .pipe(
        switchMap((containers: ContainerModel[]) => {
          if (containers?.length === 1) {
            return of(containers[0]);
          } else {
            return of({});
          }
        }),
      );
  }

  onFilterChange(data: any, containerItem: ContainerItemModel) {
    this.eventService.filterChangeEvent.emit({
      filterValues: { [containerItem?.uid]: data },
    });
  }

  clearAllFilter() {
    this.eventService.clearAllFilterEvent.emit({ onlyResetValues: false });
  }
}
